export const APP_STORE_ID = '1449704865';
export const PACKAGE_NAME = 'com.haimtov.shareitt';
export const BUNDLE_ID = 'com.haimtov.shareitt';
export const FIREBASE_DYNAMICAL_LINK_PREFIX = 'https://shareitt.page.link';
